export function slideUp(duration = 1) {
  return {
    from: {
      opacity: 0,
      y: 200,
      transition: {
        type: "ease",
        duration: duration,
      },
    },
    to: {
      opacity: 100,
      y: 0,
      transition: {
        type: "easeIn",
        duration: duration,
      },
    },
    exit: {
      opacity: 100,
      y: 0,
    },
  };
}
